export const regionSelId = "regionSelect";
export const emailId = "email";
export const passwordId = "password";
export const signErrorId = "signError";
export const testSignName = "signIn";
export const testEmailName = "email";
export const testPasswordName = "password";
export const testLogoAlt = "Safe Roads Logo";
export const testImg1Alt = "People with rocket";
export const testImg2Alt = "People with icons";
